const formatGender = (gender) => {
  switch (gender) {
    case "f":
      return "Femenino";
    case "m":
      return "Masculino";
    case "o":
      return "Otro";
    default:
      return "";
  }
};

export default formatGender;
